import React from "react";
import Accordion, {
    AccordionItem,
    AccordionTitle,
    AccordionContent,
} from "../accrodion";

const AccordionWrap = () => {
    return (
        <Accordion classOption="accordion-style2 no-bg">
            <AccordionItem id="one">
                <AccordionTitle id="one">
                    <span className="question-tag">Q:</span>What is your process
                    when you start working with a new client?
                </AccordionTitle>
                <AccordionContent id="one">
                    Pleasure rationally encounter consequences that are
                    extremely painful. Nor again there who loves or pursues or
                    desires to obtain voluptas sit aspernatur aut odit aut
                    fugit, sed consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt. Neque porro est, qui dolorem
                    ipsum quia dolor sit amet, consectetur, adipisci velit
                </AccordionContent>
            </AccordionItem>
            <AccordionItem id="two">
                <AccordionTitle id="two">
                    <span className="question-tag">Q:</span>Why should I use a
                    Travel Management Ccompany for Business Travel?
                </AccordionTitle>
                <AccordionContent id="two">
                    Pleasure rationally encounter consequences that are
                    extremely painful. Nor again there who loves or pursues or
                    desires to obtain voluptas sit aspernatur aut odit aut
                    fugit, sed consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt. Neque porro est, qui dolorem
                    ipsum quia dolor sit amet, consectetur, adipisci velit
                </AccordionContent>
            </AccordionItem>
            <AccordionItem id="three">
                <AccordionTitle id="three">
                    <span className="question-tag">Q:</span>Where can I find my
                    itinerary once my trip is booked?
                </AccordionTitle>
                <AccordionContent id="three">
                    Pleasure rationally encounter consequences that are
                    extremely painful. Nor again there who loves or pursues or
                    desires to obtain voluptas sit aspernatur aut odit aut
                    fugit, sed consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt. Neque porro est, qui dolorem
                    ipsum quia dolor sit amet, consectetur, adipisci velit
                </AccordionContent>
            </AccordionItem>
            <AccordionItem id="four">
                <AccordionTitle id="four">
                    <span className="question-tag">Q:</span>I need to make a
                    last minute cancelation or schedule change, what to do?
                </AccordionTitle>
                <AccordionContent id="four">
                    Pleasure rationally encounter consequences that are
                    extremely painful. Nor again there who loves or pursues or
                    desires to obtain voluptas sit aspernatur aut odit aut
                    fugit, sed consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt. Neque porro est, qui dolorem
                    ipsum quia dolor sit amet, consectetur, adipisci velit
                </AccordionContent>
            </AccordionItem>
            <AccordionItem id="five">
                <AccordionTitle id="five">
                    <span className="question-tag">Q:</span>Can you help with
                    other parts of my Business, too?
                </AccordionTitle>
                <AccordionContent id="five">
                    Pleasure rationally encounter consequences that are
                    extremely painful. Nor again there who loves or pursues or
                    desires to obtain voluptas sit aspernatur aut odit aut
                    fugit, sed consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt. Neque porro est, qui dolorem
                    ipsum quia dolor sit amet, consectetur, adipisci velit
                </AccordionContent>
            </AccordionItem>
            <AccordionItem id="six">
                <AccordionTitle id="six">
                    <span className="question-tag">Q:</span>How can I make a
                    profitable Business deal?
                </AccordionTitle>
                <AccordionContent id="six">
                    Pleasure rationally encounter consequences that are
                    extremely painful. Nor again there who loves or pursues or
                    desires to obtain voluptas sit aspernatur aut odit aut
                    fugit, sed consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt. Neque porro est, qui dolorem
                    ipsum quia dolor sit amet, consectetur, adipisci velit
                </AccordionContent>
            </AccordionItem>
            <AccordionItem id="seven">
                <AccordionTitle id="seven">
                    <span className="question-tag">Q:</span>What is the main
                    strategy for Stratup Business?
                </AccordionTitle>
                <AccordionContent id="seven">
                    Pleasure rationally encounter consequences that are
                    extremely painful. Nor again there who loves or pursues or
                    desires to obtain voluptas sit aspernatur aut odit aut
                    fugit, sed consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt. Neque porro est, qui dolorem
                    ipsum quia dolor sit amet, consectetur, adipisci velit
                </AccordionContent>
            </AccordionItem>
            <AccordionItem id="eight">
                <AccordionTitle id="eight">
                    <span className="question-tag">Q:</span>Hom to make
                    Marketing policy for new Business?
                </AccordionTitle>
                <AccordionContent id="eight">
                    Pleasure rationally encounter consequences that are
                    extremely painful. Nor again there who loves or pursues or
                    desires to obtain voluptas sit aspernatur aut odit aut
                    fugit, sed consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt. Neque porro est, qui dolorem
                    ipsum quia dolor sit amet, consectetur, adipisci velit
                </AccordionContent>
            </AccordionItem>
            <AccordionItem id="nine">
                <AccordionTitle id="nine">
                    <span className="question-tag">Q:</span>How much should I
                    capitalize my business with at the beginning?
                </AccordionTitle>
                <AccordionContent id="nine">
                    Pleasure rationally encounter consequences that are
                    extremely painful. Nor again there who loves or pursues or
                    desires to obtain voluptas sit aspernatur aut odit aut
                    fugit, sed consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt. Neque porro est, qui dolorem
                    ipsum quia dolor sit amet, consectetur, adipisci velit
                </AccordionContent>
            </AccordionItem>
            <AccordionItem id="ten">
                <AccordionTitle id="ten">
                    <span className="question-tag">Q:</span>Should I require
                    prospective angel or venture capital investors to sign a
                    Non-Disclosure Agreement (NDA) so they don’t steal my idea?
                </AccordionTitle>
                <AccordionContent id="ten">
                    Pleasure rationally encounter consequences that are
                    extremely painful. Nor again there who loves or pursues or
                    desires to obtain voluptas sit aspernatur aut odit aut
                    fugit, sed consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt. Neque porro est, qui dolorem
                    ipsum quia dolor sit amet, consectetur, adipisci velit
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    );
};

export default AccordionWrap;
